/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Efatura_Earsiv_FarkiInputs */

const tr_faq_q_efatura_earsiv_farki = /** @type {(inputs: Faq_Q_Efatura_Earsiv_FarkiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura ile e-Arşiv faturası arasındaki fark nedir?`)
};

const en_faq_q_efatura_earsiv_farki = /** @type {(inputs: Faq_Q_Efatura_Earsiv_FarkiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between e-Fatura and e-Arsiv?`)
};

const de_faq_q_efatura_earsiv_farki = /** @type {(inputs: Faq_Q_Efatura_Earsiv_FarkiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen e-Fatura und e-Arsiv?`)
};

const ru_faq_q_efatura_earsiv_farki = /** @type {(inputs: Faq_Q_Efatura_Earsiv_FarkiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В чём разница между e-Fatura и e-Arsiv?`)
};

/**
* | output |
* | --- |
* | "What is the difference between e-Fatura and e-Arsiv?" |
*
* @param {Faq_Q_Efatura_Earsiv_FarkiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_efatura_earsiv_farki = /** @type {((inputs?: Faq_Q_Efatura_Earsiv_FarkiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Efatura_Earsiv_FarkiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_efatura_earsiv_farki(inputs)
	if (locale === "de") return de_faq_q_efatura_earsiv_farki(inputs)
	if (locale === "ru") return ru_faq_q_efatura_earsiv_farki(inputs)
	return tr_faq_q_efatura_earsiv_farki(inputs)
});